import { m_getUrlKey } from './browser';
import { getPageNameByPath } from '@/common/constants';

// 当前页面标识：依据 location.pathname 匹配，未命中回退为原始路径
export const getPageName = () => {
  return getPageNameByPath(location.pathname) || location.pathname;
};

// 来源页标识：读取 URL 上的 fromPage
// 兼容历史短链（?fromPage=home）与完整标识（?fromPage=edu_web_home_page）
export const getFromPage = () => {
  const fromPage = m_getUrlKey('fromPage') || '';
  return getPageNameByPath(`/${fromPage}`) || fromPage;
};
